import {
  Button,
  FlexBox,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { useArticlePublish } from 'articleEditor/hooks/useArticlePublish';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useNotification } from 'lib-knowledge-utils/hooks/useNotification';
import { useCallback } from 'react';

type ArticlePublishModalProps = {
  articleId: string;
  articleTitle: string;
};

export function ArticlePublishModal({
  articleId,
  articleTitle,
}: ArticlePublishModalProps): JSX.Element {
  const { successNotify, errorNotify } = useNotification();
  const [publishFn, { loading }] = useArticlePublish({
    articleId,
  });
  const { hideModal } = useModal();

  const publish = useCallback(() => {
    publishFn()
      .then(() => {
        successNotify({
          title: 'Success',
          text: `“${articleTitle}” has been published`,
        });
        hideModal();
      })
      .catch(() => {
        errorNotify({
          title: 'Error',
          text: `“${articleTitle}” could not be published. Please try again or contact support.`,
        });
      });
  }, [publishFn, articleTitle, successNotify, hideModal, errorNotify]);

  return (
    <ModalWrapper>
      <ModalHead title="Publish Article" onClose={hideModal}></ModalHead>
      <ModalBody>
        <Text.Paragraph>
          Are you sure you want to publish <strong>“{articleTitle}”</strong>?
        </Text.Paragraph>
      </ModalBody>
      <ModalFoot>
        <FlexBox justifyContent="flex-end" gap="100">
          <Button disabled={loading} variant="tertiary" onClick={hideModal}>
            Cancel
          </Button>
          <Button disabled={loading} onClick={publish}>
            {loading ? 'Publishing...' : 'Publish'}
          </Button>
        </FlexBox>
      </ModalFoot>
    </ModalWrapper>
  );
}
